"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
function default_1(getNewHeaders, { operation, forward }) {
    return new client_1.Observable(observer => {
        const promise = Promise.resolve(getNewHeaders());
        promise
            .then(newHeaders => {
            operation.setContext(({ headers = {} }) => {
                return {
                    headers: { ...headers, ...newHeaders }
                };
            });
        })
            .then(() => {
            const subscriber = {
                next: observer.next.bind(observer),
                error: observer.error.bind(observer),
                complete: observer.complete.bind(observer)
            };
            forward(operation).subscribe(subscriber);
        })
            .catch(error => {
            observer.error(error);
        });
    });
}
exports.default = default_1;
